// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

//Load Libraries
import 'flatpickr/dist/flatpickr.min';
import 'bootstrap/js/dist/modal';

//Load Modules
import './modules/accordion';
import './modules/countUp';
import './modules/formInputs';
import './modules/formProgressBar';
import './modules/menu';
import './modules/quickExit';
import './modules/searchbarFocus';
import './modules/sliders';
import './modules/tabs';
import './modules/videoButtonReplacer';
import './modules/videoPopup';
